import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Accordion from '../../../ui_kit/accordion/Accordion';
import Store from '../store/Store';
import styles from './State.module.sass';

const DESKTOP_WIDTH_BREAKPOINT = 750;
function State(props) {
  const { state, stores, isOpened } = props;
  return (
    <div className={styles.state}>
      <MediaQuery query={`(max-width: ${DESKTOP_WIDTH_BREAKPOINT - 1}px)`}>
        <Accordion
          isOpened={isOpened}
          headingClassName={styles.heading}
          background="transparent"
          heading={<div>{state}</div>}
          content={(
            <div className={styles.stores}>
              { stores.map((store) => (
                <Store key={store.id} store={store} />
              ))}
            </div>
          )}
        />
      </MediaQuery>
      <MediaQuery query={`(min-width: ${DESKTOP_WIDTH_BREAKPOINT}px)`}>
        <div className={styles.head}>
          { state }
        </div>
        <div className={styles['desktop-stores']}>
          { stores.map((store) => (
            <Store key={store.id} store={store} />
          ))}
        </div>
      </MediaQuery>
    </div>
  );
}

State.propTypes = {
  isOpened: PropTypes.bool,
  state: PropTypes.string.isRequired,
  stores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default State;
